@use 'tokens.module' as t;

.placeholder,
.image {
  align-items: center;
  background: #e9ecef;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;

  box-shadow: t.$box-shadow;
}

.can-choose {
  background: t.$white;
  cursor: pointer;
  position: relative;

  &:before {
    position: absolute;
    z-index: 10;
    align-items: center;
    background-color: rgba($color: t.$black, $alpha: 0.7);
    border-radius: 50%;
    box-shadow: t.$box-shadow2;
    color: t.$white-ter;
    content: attr(data-text);
    display: flex;
    font-size: 18px;
    font-weight: t.$font-weight-semi-bold;
    height: 100%;
    justify-content: center;
    line-height: 100%;
    opacity: 0;
    position: absolute;
    top: 0;
    transition: opacity 0.225s ease-in-out;
    width: 100%;
  }

  &:hover:before {
    opacity: 1;
  }
}

.placeholder svg {
  color: #495056;
}

.image img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.placeholder-icon {
  width: 100%;
  height: 100%;
  transform: scale(0.5);
}